<template>
  <div id="template">
    <aside class="aside">
      <app-sidebar-header class="sidebar-header"></app-sidebar-header>
      <app-home-sidebar class="home-sidebar"></app-home-sidebar>
      <app-sidebar-footer class="sidebar-footer"></app-sidebar-footer>
    </aside>
    <section class="entry">
      <div class="search-member">
        <div class="input-group mb-3">
          <input type="text" class="form-control" v-model="search" placeholder="Find any family member" aria-label=""
                 aria-describedby="" @keyup="display = true">
        </div>
      </div>
      <div class="family-members" id="employees" v-if="display">
        <div class="row">

          <employee-card
            v-for="(employee, i) in filterEmployeeList"
            :key="i"
            :slug="employee.slug_name"
            :image="employee.profile_photo_file"
            :name="employee.name"
            :designation="employee.designation"
            :department="employee.department"
            :email="employee.office_email" :id="employee.id" :averageRating="employee.average_rating"  :totalRatingProvider="employee.total_rating_provider"
          />
        </div>
      </div>
      <div class="family-members group" id="faculty">
        <h2>All Faculties
          <span v-if="loading"><i class="fas fa-spinner fa-spin"></i></span>
        </h2>
        <div class="row">
          <employee-card
            v-for="(employee, i) in faculty"
            :key="i"
            :slug="employee.slug_name"
            :image="employee.profile_photo_file"
            :name="employee.name"
            :designation="employee.designation"
            :department="employee.department"
            :email="employee.office_email" :id="employee.id" :averageRating="employee.average_rating"  :totalRatingProvider="employee.total_rating_provider"
          />
        </div>
      </div>
      <app-footer class="footer"></app-footer>
    </section>
  </div>
</template>

<script>
import SidebarHeader from './components/SidebarHeader.vue';
import SidebarFooter from './components/SidebarFooter.vue';
import HomeSidebar from './components/HomeSidebar.vue';
import Footer from './components/Footer.vue';
import VLazyImage from "v-lazy-image";
import EmployeeCard from "./components/EmployeeCard.vue";

export default {
  components: {
    'app-footer': Footer,
    'app-sidebar-header': SidebarHeader,
    'app-sidebar-footer': SidebarFooter,
    'app-home-sidebar': HomeSidebar,
    'v-lazy-image': VLazyImage,
    'employee-card': EmployeeCard
  },
  data() {
    return {
      search: '',
      employees: [],
      faculty: [],
      display: true,
      loading: false,
    }
  },
  name: 'App',
  metaInfo() {
    return {
      meta: [
        {property: 'og:image', content: 'https://diu.ac/wp-content/themes/diu-theme-lite-v1/images/diu-logo-white.png'}
      ]
    }
  },
  mounted() {

    var current = this;

    axios.get('https://api.diu.ac/public/employees')
      .then(function (response) {
        current.employees = response.data.data;
      });

  },
  computed: {
    filterEmployeeList() {
      return this.employees.filter(employee => {
        if (this.search != '') {
          return employee.name.toLowerCase().includes(this.search.toLowerCase()) || employee.office_email.toLowerCase().includes(this.search.toLowerCase())
        }
      })
    }
  },

  methods: {
    fetchFaculty() {
      var current = this;
      this.loading = true;
      axios.get('https://api.diu.ac/public/faculty')
        .then(function (response) {
          current.faculty = response.data.data;
        }).finally(() => this.loading = false);
    }
  },

  created() {
    this.fetchFaculty();
  }
}
</script>



// WEBPACK FOOTER //
// src/Faculty.vue